import React, { useEffect } from "react";
import Aos from "aos";
export const OurPartnerStatic = ({ heading, partners }) => {
  return (
    <div className="w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px]">
      {/* <h2
        data-aos="fade-up"
        className="text-left w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
      >
        {heading}
      </h2> */}

      <h2
        data-aos="fade-up"
        className="text-left w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
      >
        {heading}
      </h2>

      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 sm:gap-[18px] mt-8">
        {partners?.map((partner, i) => (
          <div
            key={`partners-${i}`}
            data-aos="fade-up"
            className="bg-glass backdrop-blur-xl w-full"
          >
            <img src={partner} alt={`Partners-Logo-${i}`} className="w-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurPartnerStatic;
